/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Add_No_Free_SeatInputs */



/**
* | output |
* | --- |
* | "No free seat – a new one is bought" |
*
* @param {Members_Add_No_Free_SeatInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_add_no_free_seat = /** @type {((inputs?: Members_Add_No_Free_SeatInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Add_No_Free_SeatInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kein freier Platz – ein neuer wird gekauft")
	return /** @type {LocalizedString} */ ("No free seat – a new one is bought")
});